import { render } from "./ThePanelFooter.vue?vue&type=template&id=5e813f7e"
import script from "./ThePanelFooter.vue?vue&type=script&lang=js"
export * from "./ThePanelFooter.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])